import { createModel } from '@rematch/core';
import Axios from 'axios';
import { format } from 'date-fns-tz';
import getLocaleFromCulture from './getLocaleFromCulture';

type SignQuotePdfParams = {
  quoteId: string;
  fullName: string;
  signedOn: Date | undefined;
  culture: string;
};

const signPdf = createModel({
  state: {},
  effects: {
    async sign(quoteSignature: SignQuotePdfParams): Promise<void> {
      if (!quoteSignature.signedOn) {
        return Promise.resolve();
      }
      const reportsAxios = Axios.create({
        baseURL: window.AutoQuotes.config.reportsBaseUrl
      });
      const locale = getLocaleFromCulture(quoteSignature.culture);

      await reportsAxios.post(`pdf/${quoteSignature.quoteId}`, {
        fullName: quoteSignature.fullName,
        signedOn: format(quoteSignature.signedOn, 'P pp zzz', { locale }),
        culture: quoteSignature.culture
      });
      return Promise.resolve();
    }
  }
});

export default signPdf;
